import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { SingleMetricData } from '../../types';

export type SingleMetricProps = {
  showTarget?: boolean;
} & SingleMetricData;

const MetricContainer = styled('div')<{ success?: boolean }>(({ success }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'space-between',
  justifyContent: 'center',
  textAlign: 'center',
  flex: '0 0 45%',
  color: success
    ? 'var(--success-success-text-primary-color)'
    : 'var(--error-error-text-primary-color)',
  svg: {
    fill: success
      ? 'var(--success-success-icon-primary-color)'
      : 'var(--error-error-icon-primary-color)',
  },
}));

const MetricValue = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 20,
  letterSpacing: '-0.1px',
  fontWeight: 700,
  gap: theme.spacing(1),
}));

const MetricLabel = styled('span')({
  fontSize: 13,
  fontWeight: 300,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flex: 1,
});

const MetricRequirement = styled('span')({
  fontSize: 11,
  color: 'var(--text-text-tertiary-color)',
});

export const SingleMetric = ({
  showTarget,
  target,
  icon,
  label,
  value,
  required,
  success,
  targetInfo,
}: SingleMetricProps) => {
  const { t } = useI18n();

  return (
    <MetricContainer success={success}>
      <MetricValue>
        {icon}
        {showTarget ? target : value}
      </MetricValue>
      <MetricLabel>{showTarget ? targetInfo : t(label)}</MetricLabel>
      {!showTarget ? (
        <MetricRequirement>
          {t('prototypes:report.metric.required', {
            value: required,
            interpolation: {},
          })}
        </MetricRequirement>
      ) : null}
    </MetricContainer>
  );
};
